export const TransCodingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    fontSize={40}
    style={{
      animation: 'spin 2s linear infinite',
      scale: '1.5',
    }}
  >
    <style>{`
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `}</style>
    <path
      d="M10.2821 14.3805L6.75671 14.1527L6.52892 17.6781M13.7179 9.61906L17.2433 9.84686L17.4711 6.32142M7.03238 9.89752C7.49094 8.94458 8.20762 8.1394 9.10099 7.57348C9.99435 7.00756 11.0294 6.70351 12.0869 6.69608C13.1444 6.68864 14.1822 6.97795 15.0834 7.53124C15.9847 8.08454 16.7119 8.87972 17.1839 9.82611M16.968 14.1024C16.5095 15.0553 15.7928 15.8605 14.8994 16.4264C14.0061 16.9924 12.972 17.296 11.9145 17.3034C10.857 17.3109 9.81842 17.0215 8.91718 16.4683C8.01595 15.915 7.28813 15.1199 6.81622 14.1735"
      stroke="#5661F1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
